import { useMemo } from 'react';
import { useQuery } from 'react-query';

import { request, getL2AccountStatus, queryClient } from '@/utils';
import { useCurrentAddressInfo } from '@/hooks';

import { AccountStatus } from '@/consts';

export const useCurrentAddressAccount = (key?: string | number) => {
  const { address: meId } = useCurrentAddressInfo();
  return useQuery(
    ['/user/l2_account', meId, key],
    () =>
      request.get<L2AccountInfo>('/user/l2_account', {
        id: meId!,
      }),
    {
      enabled: !!meId,
    },
  );
};

export const queryL2KeyList = (meId: string) => {
  return request
    .get<{ chain_id: string; public_key: string; nonce: number; is_primary?: boolean }[]>(
      '/user/l2_key_list',
      {
        id: meId!,
      },
    )
    .then(res => {
      return {
        list: res,
        primaryL2Key: res.find(item => item.is_primary) || null,
      };
    });
};

export const useCurrentL2KeyList = () => {
  const { address: meId } = useCurrentAddressInfo();
  return useQuery(['/user/l2_key_list', meId], () => queryL2KeyList(meId!), {
    enabled: !!meId,
  });
};

export const invalidCurrentL2KeyList = () => {
  queryClient.invalidateQueries(['/user/l2_key_list']);
};

export const useL2AccountStatus = () => {
  const { data: l2KeyListData, isLoading } = useCurrentL2KeyList();
  const { account: currentAccountInfo } = useCurrentAddressInfo();

  return useMemo(
    () =>
      isLoading
        ? null
        : getL2AccountStatus(l2KeyListData?.primaryL2Key, currentAccountInfo?.publicKey) ||
          AccountStatus.NORMAL,
    [isLoading, l2KeyListData?.primaryL2Key, currentAccountInfo?.publicKey],
  );
};
